import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Nick
 * id 2D9C68D6-6DFA-42CC-B69C-E28011FC2BF7
 * name stamper
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/stamper.svg
 * tags
 */
export const StamperIcon = createSvgIcon(<><path d="M12,3A3,3 0 0,0 9,6C9,9 14,13 6,13A2,2 0 0,0 4,15V17H20V15A2,2 0 0,0 18,13C10,13 15,9 15,6C15,4 13.66,3 12,3M6,19V21H18V19H6Z" /></>, 'StamperIcon');
export default StamperIcon